import EsHomeRoadmap from '../../home/EsHomeRoadmap';
import EsHomeFinances from '../../home/EsHomeFinances';
import EsHomeContact from '../../home/EsHomeContact';
import { EsLegalLicenses, EsLegalPolicies, EsLegalThemes } from '../../legal/EsLegal';

/* A section escapade draws itself, placed by the page. The roadmap stays code (zdmorning
   reads EsRoadmapPlan), the finances and contact sections are data and forms, and the legal
   page's licences line is EsLegal's own: the notices it points at are licence conditions,
   verbatim, and never an editable field. "srd-attribution" is the marker's name before the
   notices moved to /legal/licenses; a page still carrying it draws the same line. The legal
   page's themes are esback's list of the shipped colorsheets. */
export default function EsBlockMarker( { block } ) {
    switch ( block.marker_s ) {
        case 'roadmap': return <EsHomeRoadmap />;
        case 'finances': return <EsHomeFinances />;
        case 'contact': return <EsHomeContact />;
        case 'licenses':
        case 'srd-attribution': return <EsLegalLicenses />;
        case 'policies': return <EsLegalPolicies />;
        case 'themes': return <EsLegalThemes />;
        default: return null;
    }
}
